import * as React from "react"
const CategoriesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width ?? 32}
    height={props?.height ?? props?.width ?? 32}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      stroke={props?.strokeColor ?? "#292929"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      clipPath="url(#a)"
    >
      <circle cx={17} cy={7} r={3} />
      <circle cx={7} cy={17} r={3} />
      <path d="M14 14h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5ZM4 4h6v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4Z" stroke={props?.strokeColor ?? "#292929"} />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={props?.fillColor ?? "#fff"} d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default CategoriesIcon